import { Table, Tag, Space, Button, Popconfirm, Tooltip, Modal } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  AppstoreAddOutlined,
  DeploymentUnitOutlined,
} from "@ant-design/icons";

const getStatusColor = (status) => {
  const map = {
    ACTIVE: "green",
    COMPLETED: "blue",
    ON_HOLD: "orange",
    NOT_STARTED: "default",
  };
  return map[status] || "default";
};

const formatProgress = (val) => {
  if (!val) return "";
  return val
    .replace(/_/g, " ")
    .replace(
      /\w\S*/g,
      (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
    );
};

export default function ProjectsTable({
  data,
  loading,
  isManager,
  onEdit,
  userData,
  onDelete,
  onOpenModules,
  onViewGraph,
}) {
  const showAllProgress = (progressArray) => {
    Modal.info({
      title: "Project Progress",
      icon: null,
      maskClosable: true,
      content: (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
            marginTop: "16px",
          }}
        >
          {progressArray.map((p) => (
            <Tag key={p} color="blue">
              {formatProgress(p)}
            </Tag>
          ))}
        </div>
      ),
    });
  };

  const columns = [
    {
      title: "Project Name",
      dataIndex: "title",
      key: "name",
      width: 250,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (v) => <Tag color={getStatusColor(v)}>{v}</Tag>,
    },
    {
      title: "Type",
      dataIndex: "projectType",
      key: "type",
      width: 150,
      render: (v) => (
        <Tag color={v === "owned" ? "green" : "cyan"}>
          {v === "owned" ? "Owned" : "Collaborating"}
        </Tag>
      ),
    },
    {
      title: "Progress",
      dataIndex: "progress",
      key: "progress",
      width: 220,
      render: (progressArray) => {
        // Handle empty or missing array
        if (
          !progressArray ||
          !Array.isArray(progressArray) ||
          progressArray.length === 0
        ) {
          return <span style={{ color: "gray" }}>Not Started</span>;
        }

        // Handle single item
        if (progressArray.length === 1) {
          return <Tag color="blue">{formatProgress(progressArray[0])}</Tag>;
        }

        // Handle multiple items
        return (
          <Space size={4}>
            <Tag color="blue">{formatProgress(progressArray[0])}</Tag>
            <Tag
              color="default"
              style={{ cursor: "pointer", borderStyle: "dashed" }}
              onClick={() => showAllProgress(progressArray)}
            >
              +{progressArray.length - 1} More
            </Tag>
          </Space>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      width: 250,
      render: (_, record) => (
        <Space>
          <Tooltip title="Manage Modules">
            <Button
              size="small"
              icon={<AppstoreAddOutlined />}
              onClick={() => onOpenModules(record)}
            />
          </Tooltip>
          <Tooltip title="View Flow Graph">
            <Button
              size="small"
              icon={<DeploymentUnitOutlined />}
              onClick={() => onViewGraph(record)}
            />
          </Tooltip>
          {(isManager || record.owner?.id === userData?.id) && (
            <>
              <Tooltip title="Edit Project">
                <Button
                  size="small"
                  icon={<EditOutlined />}
                  onClick={() => onEdit(record)}
                />
              </Tooltip>
              <Popconfirm
                title="Delete this project?"
                onConfirm={() => onDelete(record)}
              >
                <Button size="small" danger icon={<DeleteOutlined />} />
              </Popconfirm>
            </>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey="id"
      loading={loading}
      pagination={{ pageSize: 20, showSizeChanger: true }}
      scroll={{ x: 800 }}
    />
  );
}
